import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgManagerConsole = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
    viewBox="0 0 20 20"
    {...props}
  >
    <path stroke="#000" d="m2.917 5 4.166 4.167-4.166 4.166m3.75.834h9.166" />
  </svg>
);
const Memo = memo(SvgManagerConsole);
export default Memo;
